export const BREAKPOINTS = {
    XS: 320,
    SM: 600,
    MD: 900,
    LG: 1160,
    XL: 1400,
    XXL: 1760,
};
